import { DATA_ID, DATA_KEY, DynamicStore, load } from '@as-react/common-utils';
import { RenderClientComponent } from './components/RenderClientComponent';
import { getAemConfigurationFromBrowserContext } from './utils/browser.util';
import { performanceMark, performanceMeasure } from './utils/performance.util';
export * from './components/WrapComponent';
export * from './components/wrappers/index';
export * from './utils/wrappers.util';
export const Hydrater = async ({ availableComponents, root, renderingTools, translationLang, i18n, }) => {
    if (root.querySelectorAll(`div[data-${DATA_ID}]`).length <= 0) {
        return;
    }
    performanceMark('as-react-hydrate-start');
    const storeConfiguratorPromise = await renderingTools.redux.configureStore();
    const storeConfigurator = await storeConfiguratorPromise.default();
    const dynamicStore = new DynamicStore();
    const numeralInstance = await renderingTools.numeral();
    await searchAndHydrateComponents({
        availableComponents,
        root,
        modules: {
            redux: {
                storeConfigurator,
                dynamicStore,
            },
            i18n: {
                initialLanguage: translationLang,
                initialI18nStore: i18n.services.resourceStore.data,
            },
            numeral: numeralInstance.default,
        },
    });
    performanceMark('as-react-hydrate-end');
    performanceMeasure('as-react-hydrate', 'as-react-hydrate-start', 'as-react-hydrate-end');
};
const searchAndHydrateComponents = async ({ availableComponents, root, modules }) => {
    const aemConfiguration = getAemConfigurationFromBrowserContext();
    const availableComponentKeys = Object.keys(availableComponents);
    const reactComponentKeysInsideElement = availableComponentKeys.filter(availableComponentKey => root.querySelectorAll(`div[data-${DATA_KEY}="${String(availableComponentKey)}"]`).length > 0);
    const { allComponents, honoComponents } = reactComponentKeysInsideElement.reduce((acc, AEMScenes) => {
        const component = availableComponents[AEMScenes];
        if (component.serverOnly) {
            return acc;
        }
        if (component.compressProps) {
            acc.honoComponents.push(AEMScenes);
        }
        acc.allComponents.push(AEMScenes);
        return acc;
    }, {
        allComponents: [],
        honoComponents: [],
    });
    for (const component of allComponents) {
        const isHonoRendered = honoComponents.includes(component);
        const payloads = load(component, isHonoRendered);
        if (payloads && payloads.filter(Boolean).length > 0) {
            for (const payload of payloads) {
                const { node, data } = payload;
                if (!node) {
                    continue;
                }
                const dataWithContext = {
                    ...data,
                    context: {
                        ...(data?.context && typeof data.context === 'object' ? data.context : {}),
                        aemConfiguration,
                    },
                };
                console.log(`Hydrating component ${component} with data:`, dataWithContext);
                await RenderClientComponent(availableComponents[component], dataWithContext, node, modules);
            }
        }
    }
};
